import { createSlice } from '@reduxjs/toolkit';
import { city } from 'global/Models/globalModels';

const initialState: { allCitiesWithoutSearch?: city[] } = { allCitiesWithoutSearch: undefined };

export const citySlice = createSlice({
  name: 'city',
  initialState,
  reducers: {
    setAllCitiesWithoutSearch: (state, { payload }) => {
      state.allCitiesWithoutSearch = payload;
    },
  },
});

export const { setAllCitiesWithoutSearch } = citySlice.actions;

export default citySlice.reducer;
